import { render, staticRenderFns } from "./PreApprovedOtNew.vue?vue&type=template&id=aeb80e04"
import script from "./PreApprovedOtNew.vue?vue&type=script&lang=js"
export * from "./PreApprovedOtNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports